import { useMutation } from "@tanstack/react-query"
import axios from "axios"

export const useUploadIframeBackgroundImageMutation = () => {
  return useMutation({
    mutationFn: async (file: FileList) => {
      const { data } = await axios.post(`/integrations/widget/iframe/media`, {
        file,
      })
      return data.data
    },
  })
}
